import React, {useMemo} from 'react';
import {useGetUserAccessWidthState} from "@containers/account/access/hooks/useGetUserAccess";
import {getImpersonationActor} from "@containers/adminAccounts/helpers/impersonation";
import AccountSwitcherView from "@containers/adminAccounts/switcher/AccountSwitcherView";

/** The switcher in the header of the React pages, for a tenant administrator or while connected. */
const AccountSwitcher = () => {

	const actor = useMemo(() => getImpersonationActor(), [])
	const {access: tenantAdmin} = useGetUserAccessWidthState({keys: 'ROLE_TENANT_ADMIN'})

	return <AccountSwitcherView enabled={!!actor || tenantAdmin}/>
};

export default AccountSwitcher;
